"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hospitals = void 0;
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Resources_1 = require("../../Resources");
const Tags_1 = require("../Tags");
const Size_1 = require("../render/Size");
const LoseProduction_1 = require("../../deferredActions/LoseProduction");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const Board_1 = require("../../boards/Board");
const ResourceType_1 = require("../../ResourceType");
const SelectCard_1 = require("../../inputs/SelectCard");
const Units_1 = require("../../Units");
class Hospitals extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.HOSPITALS,
            tags: [Tags_1.Tags.BUILDING],
            resourceType: ResourceType_1.ResourceType.DISEASE,
            productionBox: Units_1.Units.of({ energy: -1 }),
            cost: 8,
            metadata: {
                cardNumber: 'X69',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.effect(undefined, (eb) => {
                        eb.city(Size_1.Size.SMALL).any.startEffect.disease();
                    }).br;
                    b.action(undefined, (eb) => {
                        eb.disease().asterix().startAction.megacredits(1).slash().city(Size_1.Size.SMALL).any;
                    }).br;
                    b.text('(Effect: When a city is placed, gain a disease here. Action: Remove a disease from ANY OF YOUR CARDS to gain 1 M€ per city in play.)', Size_1.Size.SMALL, false, false).br;
                    b.production((pb) => pb.minus().energy(1)).text('Decrease your energy production 1 step.', Size_1.Size.SMALL, false, false);
                }),
                victoryPoints: 1,
            },
        });
        this.resourceCount = 0;
    }
    canPlay(player) {
        return player.getProduction(Resources_1.Resources.ENERGY) >= 1;
    }
    play(player) {
        player.game.defer(new LoseProduction_1.LoseProduction(player, Resources_1.Resources.ENERGY, { count: 1 }));
        return undefined;
    }
    canAct(player) {
        const diseaseCardsWithResources = player.getResourceCards(ResourceType_1.ResourceType.DISEASE).filter((c) => c.resourceCount !== undefined && c.resourceCount > 0);
        return diseaseCardsWithResources.length > 0;
    }
    action(player) {
        const diseaseCardsWithResources = player.getResourceCards(ResourceType_1.ResourceType.DISEASE).filter((c) => c.resourceCount !== undefined && c.resourceCount > 0);
        const citiesInPlay = player.game.getCitiesInPlay();
        if (diseaseCardsWithResources.length === 1) {
            player.removeResourceFrom(diseaseCardsWithResources[0]);
            player.addResource(Resources_1.Resources.MEGACREDITS, citiesInPlay, { log: true });
            return undefined;
        }
        return new SelectCard_1.SelectCard('Select card to remove disease', 'Select', diseaseCardsWithResources, (foundCards) => {
            player.removeResourceFrom(foundCards[0]);
            player.addResource(Resources_1.Resources.MEGACREDITS, citiesInPlay, { log: true });
            return undefined;
        });
    }
    onTilePlaced(cardOwner, activePlayer, space) {
        if (Board_1.Board.isCitySpace(space)) {
            cardOwner.game.defer(new DeferredAction_1.DeferredAction(cardOwner, () => {
                cardOwner.addResourceTo(this, { log: true });
                return undefined;
            }), cardOwner.id !== activePlayer.id ? DeferredAction_1.Priority.OPPONENT_TRIGGER : undefined);
        }
    }
    getVictoryPoints() {
        return 1;
    }
}
exports.Hospitals = Hospitals;
//# sourceMappingURL=Hospitals.js.map